import React, { useMemo, useState } from 'react';
import { Box, Typography, Button, Paper } from '@mui/material';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong'; // Use similar icon
import AddIcon from '@mui/icons-material/Add';
import axios from 'axios';
import { ROUTE_CREATE_INVOICE, ROUTE_ROOMS_ALLOCATE, SESSION_USER_ID_KEY, SESSION_USER_ROLES_PERMISSIONS } from '../../../Util/VMConstants';
import { useNavigate } from 'react-router-dom';
import {
  checkIsPermissionExist,
  UNBOOKED_ACCOMMODATION_ALERT_MESSAGE,
} from '../../../Util/UtilHelper';
import StorageFactory from '../../../Util/StorageFactory';
import MUIAlertDialog from '../../../Components/MUIAlertDialog';
import { API_GET_BOOKED_ROOMS } from '../../../Util/URLConstants';
import Loader from '../../../Components/Loader';

const NoInvoicePlaceholder = ({ customer, enquiry_id, events = [], readOnly = false }) => {   
  
  const navigate = useNavigate();
  const [alertOpen, setAlertOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const sessionFactory = useMemo(() => new StorageFactory('session'), []);
  const VM_PERMISSIONS = sessionFactory.get(SESSION_USER_ROLES_PERMISSIONS);
  const userID = sessionFactory.get(SESSION_USER_ID_KEY);
  const resolvedEnquiryId = enquiry_id || customer?.appointment_id;

  const accommodationRoomsCount = useMemo(
    () =>
      (events || []).reduce(
        (total, event) => total + Number(event?.accomodation_no_of_rooms || 0),
        0
      ),
    [events]
  );

  const navigateToCreateInvoice = () => {
    navigate('/' + ROUTE_CREATE_INVOICE, {
      state: { enquiry_id: resolvedEnquiryId, events },
    });
  };

  const handleCreateInvoice = async () => {
    if (accommodationRoomsCount <= 0) {
      navigateToCreateInvoice();
      return;
    }

    if (!userID || !resolvedEnquiryId) {
      setAlertOpen(true);
      return;
    }

    setLoading(true);
    try {
      const resp = await axios.get(
        `${API_GET_BOOKED_ROOMS}?user_id=${userID}&enquiry_id=${resolvedEnquiryId}`
      );
      const roomsInfo = resp?.data?.data?.rooms_info ?? [];

      if (!roomsInfo.length) {
        setAlertOpen(true);
        return;
      }

      navigateToCreateInvoice();
    } catch (err) {
      console.error('Error fetching booked rooms:', err);
      setAlertOpen(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        position: 'relative',
        // width: 175,
        height: 260, // 180 + 44 + margin
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        gap: 2,
      }}
    >
      {/* Circle background with icon */}
      <Paper
        elevation={0}
        sx={{
          width: 82,
          height: 82,
          borderRadius: '50%',
          backgroundColor: '#F0F0F0',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          position: 'absolute',
          top: 76 - 60, // adjust relative to outer box
        }}
      >
        <ReceiptLongIcon sx={{ width: 56, height: 56, color: '#354052' }} />
      </Paper>

      {/* Text below the icon */}
      <Typography
        sx={{
          mt: 10, // to push below the icon
          textAlign: 'center',
          fontFamily: 'Lato',
          fontSize: 16,
          lineHeight: '24px',
          color: '#1E1E1E',
        }}
      >
      No Invoices Created Yet!
      </Typography>
      <Typography
        sx={{
          textAlign: 'center',
          fontFamily: 'Lato',
          fontSize: 16,
          fontWeight: 600,
          // lineHeight: '24px',
          color: '#1E1E1E',
        }}
      >
      Once an invoice is created, it cannot be changed or edited.
      </Typography>

      {
        !readOnly && checkIsPermissionExist(VM_PERMISSIONS,'VM005')
        &&
       <Button
        variant="contained"
        color="primary"
        startIcon={<AddIcon />}
        sx={{
          mt: 2,
          width: 175,
          height: 44,
          borderRadius: '4px',
          fontFamily: 'Lato',
          fontSize: 16,
        }}
        onClick={handleCreateInvoice}
      >
        Create Invoice
      </Button>
      }

      <MUIAlertDialog
        open={alertOpen}
        onClose={() => setAlertOpen(false)}
        message={UNBOOKED_ACCOMMODATION_ALERT_MESSAGE}
        okClickHandler={() => {
          setAlertOpen(false);
          navigate("/"+ROUTE_ROOMS_ALLOCATE,{ state: { customer: customer,events:events ,displayHeading:false  } } ); 
        }}
      />

      <Loader loading={loading} />
    </Box>
  );
};

export default NoInvoicePlaceholder;
